import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  CheckCircle as CircleCheckedIcon,
  RadioButtonUnchecked as CircleUncheckedIcon,
} from "@mui/icons-material";
import styles from './CircleCheckbox.module.css';

const CircleCheckbox = ({ className, checked, style, ...props }) => (
  <div
    className={classnames(styles.circleCheckboxWrapper, {
      [className]: className,
    })}
  >
    <input
      className={styles.circleCheckboxInput}
      id="testId"
      type="checkbox"
      {...props}
    />
    <label htmlFor="testId" className={styles.circleCheckboxIcon}>
      {checked ? (
        <CircleCheckedIcon style={style} />
      ) : (
        <CircleUncheckedIcon style={style} />
      )}
    </label>
  </div>
);

CircleCheckbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types,
};

CircleCheckbox.defaultProps = {
  className: null,
  checked: false,
  style: {},
};

export default CircleCheckbox;
